import { testimonials } from "@/mocks/site";

const Testimonials = () => (
  <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
    <div className="max-w-7xl mx-auto">
      <div className="text-center max-w-2xl mx-auto mb-8 md:mb-12">
        <p className="text-sm font-medium text-primary-600 mb-2">吃瓜群众说</p>
        <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
          他们这样用档案局
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex flex-col p-5 md:p-7 rounded-lg bg-background-50 border border-background-200/80"
          >
            <i className="ri-double-quotes-l text-3xl text-primary-300" />
            <blockquote className="mt-4 text-sm md:text-base text-foreground-800 leading-relaxed flex-1">
              {item.text}
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-background-200/80 flex items-center gap-3">
              <img
                src={item.avatar}
                alt={`${item.name} 头像`}
                className="w-11 h-11 rounded-full object-cover border border-background-200"
              />
              <span>
                <span className="block font-heading font-bold text-sm text-foreground-950">
                  {item.name}
                </span>
                <span className="block text-xs text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;